import {inject, Injectable} from '@angular/core';
import { BaseService, RequestOptions } from './base.service';
import { Observable, shareReplay } from 'rxjs';
import { ContainerPopoverContent } from '../models/container-popover-content.interface';

@Injectable({
	providedIn: 'root',
})
export class ContainerPopoverContentService {

	private static readonly REQUEST_TOP_PATH: string = "ContainerPopoverContent";

	private _baseService: BaseService = inject(BaseService);

	public getContainersPopoverContents(routeId: number, requestOptions?: RequestOptions): Observable<ContainerPopoverContent[]> {
		const requestEndpoint: string = "GetContainersPopoverContents";

		let url = `${ContainerPopoverContentService.REQUEST_TOP_PATH}/${requestEndpoint}?routeId=${routeId}`;

		return this._baseService.get<ContainerPopoverContent[]>(
			url,
			requestOptions
		).pipe(
			shareReplay(1)
		);
	}
}
